var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "drag-mask" }, [
        _c("div", { staticClass: "dashed-box" }, [
          _c(
            "div",
            { staticClass: "tip-box" },
            [
              _c("svg-icon", {
                staticClass: "dashed-box-icon",
                attrs: { "icon-class": "mask-icon" },
              }),
              _c("span", [_vm._v("拖入此处后松开鼠标上传")]),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }